<template>
  <div class="add-name-modal">
    <div v-if="loadModal" class="modal modal-mask">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header div-responsive">
            <div class="modal-title">
              <h1>Examinee Name</h1>
            </div>
            <button type="button" class="close-icon" @click="handleModal($event)" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body div-responsive">
            <div class="box-body">
              <div class="box-row">
                <div class="box-col box-col-left">First Name</div>
                <div class="box-col box-col-right">
                  <input type="text" :class="hasError && firstNameError ? 'is-invalid' : ''" v-model="name.firstName" placeholder="First Name" @input="changeText" @blur="trimName('firstName')" />
                  <div class="text-danger" v-if="hasError && firstNameError">{{ firstNameError }}</div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Middle Name/s</div>
                <div class="box-col box-col-right">
                  <input type="text" :class="hasError && middleNameError ? 'is-invalid' : ''" v-model="name.middleName" placeholder="Middle Name/s (optional)" @input="changeText" @blur="trimName('middleName')" />
                  <div class="text-danger" v-if="hasError && middleNameError">{{ middleNameError }}</div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Surname</div>
                <div class="box-col box-col-right">
                  <input type="text" :class="hasError && surnameError ? 'is-invalid' : ''" v-model="name.surname" placeholder="Surname" @input="changeText" @blur="trimName('surname')" />
                  <div class="text-danger" v-if="hasError && surnameError">{{ surnameError }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="icon-group right-float-element">
                  <v-btn class="white-button" @click="handleModal($event)" dark>Cancel</v-btn>
                  <v-btn @click="save" dark>Save</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'

export default {
  name: 'AdminAddNameModal',
  data() {
    return {
      loadModal: false,
      hasError: false,

      name: {
        caseId: "",
        firstName: "",
        middleName: "",
        surname: "",
        fullName: "",
        dateOfBirth: "",
      },

      cases: [],
    }
  },
  computed: {
    firstNameError() {
      return utilities.getClientContactPersonNameError(this.name.firstName, 'First name')
    },
    middleNameError() {
      return utilities.getClientContactMiddleNameError(this.name.middleName)
    },
    surnameError() {
      return utilities.getClientContactPersonNameError(this.name.surname, 'Surname')
    },
  },
  methods: {
    trimName(part) {
      const key = part === 'firstName' ? 'firstName' : part === 'middleName' ? 'middleName' : 'surname'
      const v = this.name[key]
      if (v === undefined || v === null) return
      this.name[key] = String(v).trim()
    },
    handleModal(e) {
      this.loadModal = !this.loadModal
      if (this.loadModal) {
        $('html').addClass('modal-mask-open')
      } else {
        $('html').removeClass('modal-mask-open')
      }
    },
    changeCase() {
      var singleCase = this.cases.find(x => x.id == this.name.caseId)
      this.name.firstName = singleCase != undefined ? singleCase.claimantFirstName : ""
      this.name.middleName = singleCase != undefined ? singleCase.claimantGivenNames : ""
      this.name.surname = singleCase != undefined ? singleCase.claimantSurname : ""
      this.name.fullName = singleCase != undefined ? singleCase.claimantFullName : ""
      this.name.dateOfBirth = singleCase != undefined ? singleCase.dateOfBirth : ""
    },
    changeText() {
      this.name.caseId = ""
    },
    loadName(claimant) {
      this.name.firstName =  claimant.claimantFirstName
      this.name.middleName =  claimant.claimantGivenNames
      this.name.surname =  claimant.claimantSurname
      this.name.fullName =  claimant.claimantFullName
    },
    save() {
      this.trimName('firstName')
      this.trimName('middleName')
      this.trimName('surname')
      if (this.firstNameError || this.middleNameError || this.surnameError) {
        this.hasError = true
        return false
      }
      this.hasError = false

      this.$parent.loadName(this.name)
      this.handleModal()
    },
  },
  beforeMount() {},
  mounted() {},
}
</script>
